/**
 * «Інші перевізники» (`SPEC-010` §5.5, §9.7): контракт картки так, як її
 * тримає форма, — лише те, що читає фронт.
 *
 * Права — `_permissions` з `?permissions=true` (`OtherCarrierRule`): усі
 * операції, включно з читанням, — лише логістам. Ролей фронт не питає
 * (`SPEC-003` §1.3).
 */
export interface OtherCarrierPermissions {
    read?: boolean
    update?: boolean
    delete?: boolean
    comment?: boolean
}

/** Рядок довідника («Типи авто», «Країни») у відповіді — з `title`. */
export interface OtherCarrierDictionaryRef {
    '@id'?: string
    uuid?: string
    code?: string
    title?: string
}

export interface OtherCarrierCardValues {
    uuid?: string
    '@id'?: string
    title?: string
    edrpou?: string
    carTypes?: OtherCarrierDictionaryRef[] | null
    countries?: OtherCarrierDictionaryRef[] | null
    _permissions?: OtherCarrierPermissions
    [key: string]: unknown
}

/** Те, що шаблон картки бере з ядрового `formContext`. */
export interface OtherCarrierFormContextLike {
    isEditable?: boolean
    values?: OtherCarrierCardValues
}

/** Те, що шаблон картки бере з ядрового `crudContext`. */
export interface OtherCarrierCrudContextLike {
    resource?: { key?: string; restUrl?: string; fields?: Record<string, unknown> }
}

/** Ключ ресурсу — під ним права (`OtherCarrier`), пункт меню й `GATED_MENU_ITEMS`. */
export const OTHER_CARRIER_RESOURCE = 'Crm.OtherCarrier'

/** Колекція інших перевізників. */
export const OTHER_CARRIER_REST_URL = '/services/other_carriers'

/** Коментарі (`SPEC-010` §5.6, ADR 027): поле власника — `otherCarrier`. */
export const OTHER_CARRIER_COMMENT_REST_URL = '/services/other_carrier_comments'

/** Межі полів — ті самі, що в `OtherCarrierEntity` на беку. */
export const OTHER_CARRIER_TITLE_MAX_LENGTH = 150
export const OTHER_CARRIER_EDRPOU_MAX_LENGTH = 12
export const OTHER_CARRIER_TEXT_MAX_LENGTH = 4096

/** Підписи полів (`OtherCarrierResource.js:7-40` легасі; `SPEC-010` §9.7). */
export const OTHER_CARRIER_FIELD_LABELS = {
    id: 'Ід',
    title: 'Назва',
    carTypes: 'Типи авто',
    countries: 'Країни перевезення',
    edrpou: 'Код ЄДРПОУ',
    contactInformation: 'Контактна інформація',
    description: 'Опис',
    comment: 'Коментар',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const
